<template>
  <v-card tile>
    <v-card-text>
      <h4 mt-2>LISTE DES BESOINS VEHICULES A VALIDER</h4>
      <v-divider></v-divider>
      <v-layout wrap>
        <v-flex class="text-xs-right" xs12 mt-2>
          <v-tooltip top>
            <v-btn
              :disabled="disabledBtnAchat"
              slot="activator"
              icons
              class="white--text"
              color="primary"
              @click.stop="modalShowServiceAchat()"
            >
              Service achat
              <v-icon right>shopping_cart</v-icon> </v-btn
            >Envoyer les besoins selectionnés au service achat
          </v-tooltip>
        </v-flex>
        <v-flex xs12 mt-2>
          <data-tables
            mt-3
            ml-1
            mr-1
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :data="listeBesoinsVeh"
            style="width:100%;"
          >
            <el-table-column width="55" type="selection"></el-table-column>
            <el-table-column prop="id" label="ID" align="center">
              <template slot-scope="scope">
                ID-{{ scope.row.id }}
              </template>
            </el-table-column>
            <el-table-column
              prop="dateC"
              label="DATE"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="produit"
              label="VEHICULE"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="qte"
              label="QUANTITE"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="unite"
              label="UNITE"
              align="center"
            ></el-table-column>
            <el-table-column prop="periode" label="PERIODE" align="center">
              <template slot-scope="scope">
                {{ scope.row.periode }}
              </template>
            </el-table-column>
            <el-table-column
              prop="duree"
              label="DUREE(Jours)"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="demandeur"
              label="DEMANDEUR"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="respoProjet"
              label="RESPONSABLE PROJET"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="libelle"
              label="PROJET/CHANTIER/TRAVAUX"
              align="center"
            ></el-table-column>
            <el-table-column label="Action" align="center" fixed="right">
              <template slot-scope="scope">
                <v-tooltip top>
                  <v-btn
                    class="tooltip-btn"
                    title="Attribuer un vehicule" 
                    slot="activator"
                    @click="modalAttribVehicule(scope.row)"
                    fab
                    dark
                    small
                    color="blue"
                  >
                    <v-icon dark>list</v-icon> </v-btn
                  >
                </v-tooltip>
              </template>
            </el-table-column>
          </data-tables>
        </v-flex>
      </v-layout>
    </v-card-text>
    <!-- MODAL VALIDATION BESOIN -->

    <!-- MODAL VALIDATION SERVICE ACHAT -->
    <v-layout row justify-center>
      <v-dialog v-model="dialogBesoinAchat" persistent max-width="800">
        <v-card>
          <v-card-title class="headline"
            >VALIDATION DES BESOINS EN VEHICULE SELECTIONNES</v-card-title
          >
          <v-card-text class="mb-5">
            <el-alert
              :title="
                'Voulez-vous transferer les besoins selectionnés au service achat ?'
              "
              description="Les besoins selectionnés seront transferés au service achat pour établir une commande chez un fournisseur"
              type="warning"
              center
              :closable="false"
              show-icon
            >
            </el-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="dialogBesoinAchat = false"
              >Annuler</v-btn
            >
            <v-btn color="green darken-1" @click="validBesoinAchat(1)" flat
              >Confirmer</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- MODAL VALIDATION SERVICE ACHAT-->

    <!-- MODAL ATTRIBUTION VEHICULE -->
    <v-layout row justify-center>
      <v-dialog v-model="dialogAttriVeh" persistent max-width="800">
        <v-card>
          <v-card-title class="headline"
            >ATTRIBUER UN VEHICULE A DES TRAVAUX</v-card-title
          >
          <v-card-text class="mb-5">
            <el-alert
              :title="
                'Affecter ' +
                  besoinSelect.qte +
                  ' véhicule(s) pour les travaux de ' +
                  besoinSelect.libTrx +
                  ' pour une durée de ' +
                  besoinSelect.duree +
                  ' jours'
              "
              description="Veuillez selectionner un vehicule, ainsi que le nombre exacte pour ces travaux"
              type="warning"
              center
              :closable="false"
              show-icon
            >
            </el-alert>
            <!--Formulaire Frais de mission-->
            <v-flex xs12 mt-3>
              <el-form
                :inline="true"
                :model="formAttrib"
                class="demo-form-inline"
                label-position="top"
              >
              <el-form-item label="Parc" width="50%">
                <el-select
                    name="valeurSelect"
                    id="valeurSelect"
                    v-model="selectParc"
                    v-on:change="loadTypeParc(selectParc)"
                    placeholder="Sélectionnez un parc"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in listParc"
                      :key="item.id"
                      :label="item.libelle"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Véhicule" width="50%">
                  <el-select
                    width="100%"
                    v-model="formAttrib.idVeh"
                    placeholder="Sélectionnez un véhicule"
                  >
                    <el-option
                      v-for="item in comboVeh"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Quantité">
                  <el-input-number
                    :min="1"
                    :max="besoinSelect.qte"
                    size="large"
                    controls-position="right"
                    v-model="formAttrib.qte"
                    placeholder="Quantité"
                  ></el-input-number>
                </el-form-item>
              </el-form>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="dialogAttriVeh = false">Annuler</v-btn>
            <v-btn color="green darken-1" @click="attribVeh()" flat
              >Confirmer</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- MODAL ATTRIBUTION VEHICULE-->
  </v-card>
</template>

<script>
//liste l'ensemble  des besoins  ou les besoinsa valider par un responsable
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "ListeBesoinTravaux",
  props: {
    show: {
      type: Boolean
    },
    idresponsable: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      dialogBesoinAchat: false,
      dialogAttriVeh: false,
      multipleSelection: [],
      disabledBtnAchat: true,
      disabledAttriVeh: false,
      formAttrib: {},
      besoinSelect: {},
      listeBesoinsVeh: [],
      comboVeh: [],
      listParc:'',
      selectParc:''
    };
  },
  methods: {
    loadVehicule() {
      let url = this.domaine + "vehicule/liste_vehicule";
      this.$http.get(url).then(response => {
        this.comboVeh = response.body.vehicule;
      });
    },
    modalAttribVehicule(item) {
      this.besoinSelect = item;
      this.dialogAttriVeh = true;
    },

    modalShowServiceAchat() {
      this.dialogBesoinAchat = true;
    },
    attribVeh() {
      this.loading = true;
      let url = this.domaine + "besoin/attribuer/vehicule";
      let formdata = new FormData();
      formdata.append("idVeh", this.formAttrib.idVeh);
      formdata.append("qte", this.formAttrib.qte);
      formdata.append("idBesoin", this.besoinSelect.id);
      formdata.append("idUser", this.user.id);
      this.$http.post(url, formdata).then(
        response => {
          this.loading = false;
          this.dialogAttriVeh = false;
          this.selectParc =''
          this.formAttrib.idVeh=''
          this.formAttrib.qte=''
          this.loadBesoinVehAvalider();
          this.$emit("reloadBesoinValider");
          this.$notify({
            title: "Validation besoins",
            message: "L'opération s'est déroulée avec succès",
            type: "success",
            position: "top-center"
          });
        },
        error => {
          this.loading = false;
          this.dialogAttriVeh = false;
          this.$message.error(
            "Erreur lors de l'attribution du véhicule aux travaux"
          );
        }
      );
    },
    validBesoinAchat(decision) {
      this.loading = true;

      //decision == 1 = Valider // decision == 0 //Refuser
      var formdata = new FormData();
      let url = this.domaine + "besoin/transfert";
      let optBesoins = [];
      for (let prop in this.multipleSelection) {
        let ligne = this.multipleSelection[prop];
        optBesoins.push(ligne.id);
      }
      formdata.append("optBesoins", optBesoins);
      formdata.append("decision", decision);
      this.$http.post(url, formdata).then(
        response => {
          this.loadBesoinVehAvalider();
          this.dialogBesoinAchat = false;
          this.loading = false;
          this.$emit("reloadBesoinValider");
          this.$notify({
            title: "Validation besoins",
            message: "L'opération s'est déroulée avec succès",
            type: "success",
            position: "top-center"
          });
        },
        error => {
          this.dialogBesoinAchat = false;
          this.loading = false;
          this.$message.error(
            "Erreur lors du chargement de la validation des besoins"
          );
        }
      );
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnAchat = true;
      } else {
        this.disabledBtnAchat = false;
      }
    },
    loadBesoinVehAvalider() {
      this.loading = true;
      let url = this.domaine + "besoin/vehicule";
      this.$http.get(url).then(response => {
        this.listeBesoinsVeh = response.body.besoins;
        this.nbBesoins = response.body.besoins.length;
        this.loading = false;
      });
    },
    loadTypeParc(item) {
      this.loading = true;
      let url = this.domaine + "parc/parcSelect/" + item;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.comboVeh = response.body.detailVehi;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste des vehicules"
          );
        }
      );
    },
    loadParc() {
      let url = this.domaine + "parc/index/parc";
      this.$http.get(url).then(response => {
        if (response.body.parc) {
          var tableau = response.body.parc;
          for (var i = 0; i < tableau.length; ++i) {
            for (var j = i + 1; j < tableau.length; ++j) {
              if (tableau[i].libelle === tableau[j].libelle) {
                tableau.splice(j--, 1);
              }
            }
          }
          this.listParc = tableau;
        }
      });
    }
  },
  mounted() {
    this.loadVehicule();
    this.loadParc();
    this.loadBesoinVehAvalider();
  }
};
</script>
<style>
    .el-tabs--border-card
    {
        background: #FAFAFA;
    }

    .tooltip-btn {
    position: relative;
    background-color: grey;
    color: white;
  }

  .tooltip-btn::after {
    content: attr(title);
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px;
    border-radius: 5px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    color: white;
    transition: opacity 0.9s, visibility 0.9s;
  }

  .tooltip-btn:hover::after {
    opacity: 1;
    visibility: visible;
  }
</style>



// WEBPACK FOOTER //
// src/components/besoin/listeBesoinTravaux.vue